module.exports = __webpack_public_path__ + "static/media/class_one.5292a313.png";